<template>
  <div>

  <div class="row">
    <div class="form-group col-md-12">
      <div class="card">
        <div class="card-header">
          {{ $t('project.company.form.finances.historyTitle') }}

          <div class="float-right" v-if="compMode == CRUDMODE.READ">
            <ul class="nav nav-pills">
              <li class="nav-item">
                <a :class="visualization == 1 ? 'nav-link active' : 'nav-link'" href="#financialInfo1" name="financialInfo1" @click="setVisualisation(1)">Détails</a>
              </li>
              <li class="nav-item">
                <a :class="visualization == 2 ? 'nav-link active' : 'nav-link'" href="#financialInfo2" name="financialInfo2" @click="setVisualisation(2)">Progression</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive" v-if="compMode != CRUDMODE.READ">
            <table class="table table-bordered table-striped" id="dataTableHistoc" width="100%" cellspacing="0">
              <thead>
                <tr>
                  <th>{{ $t('project.company.form.finances.status') }}</th>
                  <th width="250">{{ $t('project.company.form.finances.creationTime') }}</th>
                  <th width="250">{{ $t('project.company.form.finances.lastModifiedTime') }}</th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                  <th>{{ $t('project.company.form.finances.status') }}</th>
                  <th>{{ $t('project.company.form.finances.creationTime') }}</th>
                  <th>{{ $t('project.company.form.finances.lastModifiedTime') }}</th>
                </tr>
              </tfoot>
              <tbody>
                <tr v-for="item in financialInformations" v-bind:data-id="item.id">
                  <td><a v-bind:href="'#' + item.id" v-bind:name="item.id" @click="openHistory(item)">
                    {{ item.status ? $t('project.company.form.finances.actif') : $t('project.company.form.finances.history') }}</a>
                  </td>
                  <td>{{ item.creation | formatDateTime }}</td>
                  <td>{{ item.historique | formatDateTime }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-if="compMode == CRUDMODE.READ">
            <ul class="item-view" v-if="visualization == 1">
              <li v-if="financialInformations == null || financialInformations.length == 0">
                {{ $t("form.aucun_donne") }}
              </li>
              <li v-for="(item, index) in order(financialInformations)" v-bind:data-id="item.id" :key="item.id">
                <create-financial-information v-bind:financial-information="item" v-bind:emptyFinancialInformation="false" :showFixedData="index == 0" v-bind:entite="entite" :compMode="'read'"></create-financial-information>
              </li>
            </ul>

            <div v-if="visualization == 2">
              <div id="financialInfoPivotTable"></div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>

  <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" >
      <div class="modal-dialog modal-lg">
          <div class="modal-content">
              <div class="modal-header">
                  <h4 class="modal-title" id="myModalLabel">{{ $t('project.company.form.finances.title') }}</h4>
              </div>
              <div class="modal-body">
              
                <create-financial-information v-bind:financial-information="financialInformation" v-bind:entite="entite" :compMode="'read'"></create-financial-information>
              
              </div>
              <div class="modal-footer">
                  <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
              </div>
          </div>
      </div>
  </div>

</div>
  
</template>

<script>
import CrudMixin from '../../shared/Mixin/CrudMixin'
import CreateFinancialInformation from './CreateFinancialInfo.vue'
import {FinancialInformationDto} from '../../shared/service-clients/service-clients'

export default {
  name: 'FinancialInformation',
  props: ['financialInformations', 'entite'],
  mixins: [CrudMixin],
  data() {
    return {
      financialInformation: new FinancialInformationDto(),
      visualization: 1,
      pivotalData: [],
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      setTimeout(function() {
        $('#dataTableHistoc').dataTable()
      }, 700)
    })
  },

  methods: {
    order: function(list) {
      return _.orderBy(list, 'creation', 'desc')
    },
    setVisualisation: function(visualisation) {
      this.visualization = visualisation

      if (this.visualization == 2) {
        if (this.pivotalData.length == 0) {
          Array.prototype.push.apply(
            this.pivotalData,
            _.chain(this.financialInformations)
              .map(value => ({
                Information: this.$t('project.company.form.finances.comparableValue'),
                Valeur: value.comparableValue,
                Date: value.creation.format('DD-MM-YYYY'),
              }))
              .value()
          )

          Array.prototype.push.apply(
            this.pivotalData,
            _.chain(this.financialInformations)
              .map(value => ({
                Information: this.$t('project.company.form.finances.turnover'),
                Valeur: value.turnover,
                Date: value.creation.format('DD-MM-YYYY'),
              }))
              .value()
          )

          Array.prototype.push.apply(
            this.pivotalData,
            _.chain(this.financialInformations)
              .map(value => ({
                Information: this.$t('project.company.form.finances.netProfit'),
                Valeur: value.netProfit,
                Date: value.creation.format('DD-MM-YYYY'),
              }))
              .value()
          )

          Array.prototype.push.apply(
            this.pivotalData,
            _.chain(this.financialInformations)
              .map(value => ({
                Information: this.$t('project.company.form.finances.baiiaEbitda'),
                Valeur: value.baiiaEbitda,
                Date: value.creation.format('DD-MM-YYYY'),
              }))
              .value()
          )

          Array.prototype.push.apply(
            this.pivotalData,
            _.chain(this.financialInformations)
              .map(value => ({
                Information: this.$t('project.company.form.finances.exportationIncomePercentage'),
                Valeur: value.exportationIncomePercentage,
                Date: value.creation.format('DD-MM-YYYY'),
              }))
              .value()
          )

          Array.prototype.push.apply(
            this.pivotalData,
            _.chain(this.financialInformations)
              .map(value => ({
                Information: this.$t('project.company.form.finances.quebecIncomePercentage'),
                Valeur: value.quebecIncomePercentage,
                Date: value.creation.format('DD-MM-YYYY'),
              }))
              .value()
          )

          Array.prototype.push.apply(
            this.pivotalData,
            _.chain(this.financialInformations)
              .map(value => ({
                Information: this.$t('project.company.form.finances.employeeCountFullTime'),
                Valeur: value.employeeCountFullTime,
                Date: value.creation.format('DD-MM-YYYY'),
              }))
              .value()
          )

          Array.prototype.push.apply(
            this.pivotalData,
            _.chain(this.financialInformations)
              .map(value => ({
                Information: this.$t('project.company.form.finances.employeeCountFullPart'),
                Valeur: value.employeeCountFullPart,
                Date: value.creation.format('DD-MM-YYYY'),
              }))
              .value()
          )

          Array.prototype.push.apply(
            this.pivotalData,
            _.chain(this.financialInformations)
              .map(value => ({
                Information: this.$t('project.company.form.finances.employeeCountOthers'),
                Valeur: value.employeeCountOthers,
                Date: value.creation.format('DD-MM-YYYY'),
              }))
              .value()
          )

          Array.prototype.push.apply(
            this.pivotalData,
            _.chain(this.financialInformations)
              .map(value => ({
                Information: this.$t('project.company.form.finances.employeeCountTotal'),
                Valeur: value.employeeCountOthers + value.employeeCountFullTime + value.employeeCountFullPart,
                Date: value.creation.format('DD-MM-YYYY'),
              }))
              .value()
          )
        }

        let self = this

        setTimeout(function() {
          var average = $.pivotUtilities.aggregatorTemplates.average
          var numberFormat = $.pivotUtilities.numberFormat
          var intFormat = numberFormat({digitsAfterDecimal: 2})

          $('#financialInfoPivotTable').pivot(self.pivotalData, {
            rows: ['Information'],
            cols: ['Date'],
            aggregator: average(intFormat)(['Valeur']),
          })

          $('#financialInfoPivotTable .pvtGrandTotal')
            .parent()
            .hide()

          $('.pvtTable').addClass('table table-bordered table-striped dataTable')
          $('.pvtTotalLabel').text('Moyenne')
        }, 500)
      }
    },
    fetchData: function() {},
    openHistory: function(item) {
      this.financialInformation = item
      $('#myModal').modal()
    },
  },
  components: {
    createFinancialInformation: CreateFinancialInformation,
  },
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/projects/FinancialInfo.vue